var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-total"},[_c('p',[_vm._v(_vm._s(_vm.$t( 'cart.money_back' )))]),_vm._v(" "),_c('button',{class:[_vm.loading || _vm.disabled ? 'disabled' : ''],attrs:{"ga-label":"Cart confirm(subscribe)"},on:{"click":_vm.subscribe}},[_vm._v(_vm._s(_vm.button))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e84922","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cartTotal.vue
// module id = null
// module chunks = 